import commonNav from '@/components/common-nav/index.vue';
import common from '@/util/common';
import {
	createNamespacedHelpers
} from 'vuex';
const sroreName = {
  apply: 'apply',
};
const {
  mapState,
	mapActions,
} = createNamespacedHelpers(sroreName.apply);
export default {
	data() {
		return {
			oldPassword: '',
			newPassword: '',
			sureNewPassword: '',

			userName:'',
			sex:0,
			age:'',
			email:'',
			phone:'',

      form: {
        first_name: '',
        last_name: '',
        name: '',
        email: '',
        phone: '',
        weixin: '',
        is_live: '',
        study_time: '',
        channel: '',
        desc: '',
        country: '',
      }
            
		};
	},
	components: {
		'common-nav': commonNav,
	},
	watch: {
		
	},
  computed: {
    ...mapState({

    })
  },
	methods: {
		...mapActions({
      postQuest: 'postQuest'
		}),
		goBack(){
			setTimeout(()=>{
        common.goBack(this);
      },1000);
		},
		async submitData(){
      const param = {
        content: this,
        data: {
          first_name:this.form.first_name,
          last_name:this.form.last_name,
          email:this.form.email,
          phone:this.form.phone,
          weixin:this.form.weixin,
          in_jap:this.form.is_live,
          overseas_study:this.form.study_time,
          channel:this.form.channel,
          ask_info:this.form.desc,
          country:this.form.country,
        }
      };

      const rlt = await this.postQuest(param);
      if(rlt.code){
        /*common.toast('提交成功','success',()=>{
          common.goBack(this);
        });*/
        this.$message({
          message: rlt.msg,
          type: 'success',
          onClose:common.goBack(this)
        });
      }else {
        this.$message.error(rlt.msg);
			}
		},
	}
};
